module.exports = __webpack_public_path__ + "img/shipbuild-pathway.d9e9d9cf.jpg";